import { useEffect, useState } from "react";

import { useSearchResultsContext } from "@/components/Search/SearchResults/context/searchResults.context";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as SearchModule from "@/redux/modules/value/search/search.module";
import { SearchStatus } from "@/redux/modules/value/search/search.types";
import * as AlgoliaUserService from "@/services/algolia/algoliaUser.service";
import { getDefaultConfigurationValues } from "@/utils/search/defaultConfiguration";

export const useInitSearch = () => {
    const { algoliaSearchParameters } = useSearchResultsContext();

    const [initialized, setInitialized] = useState(false);

    const dispatch = useThunkDispatch();

    useEffect(() => {
        if (initialized) return;

        dispatch(
            SearchModule.set({
                status: SearchStatus.Loading,
                configuration: {
                    filters: algoliaSearchParameters?.filters,
                    query: algoliaSearchParameters?.query,
                    userToken:
                        AlgoliaUserService.getAuthenticatedUserToken() ??
                        AlgoliaUserService.getUserToken(),
                    components: getDefaultConfigurationValues().map(
                        (config) => {
                            if (
                                config.component === "PRODUCT_SORT" &&
                                algoliaSearchParameters?.sort
                            ) {
                                config.sortBy = algoliaSearchParameters?.sort;
                            }

                            return config;
                        }
                    ),
                    categoryPagePaths:
                        algoliaSearchParameters?.categoryPagePaths
                }
            })
        );

        setInitialized(true);
    }, [initialized, algoliaSearchParameters, dispatch]);

    return {
        initialized: initialized
    };
};
